import { Component, input } from '@angular/core';

@Component({
  selector: 'customer-g2m-intro',
  templateUrl: './g2m-intro.component.html',
  styleUrls: ['./g2m-intro.component.scss'],
  standalone: false
})
export class G2mIntroComponent {
  readonly maxHeight = input<string>(undefined);
}
